
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import {
  addStockInoutType,
  addStockWarningUser,
  delStockInoutType,
  editorStockInoutType,
  getStockInoutTypeList,
  getStockWarningUserList,
  getSyncPartsFailList } from '@/api/stock';
  import {
  getShellRecordList
} from '@/api/shellRecord';
import DialogSetStaff from '../staff/components/setStaff.vue';
import { getCompanySet, modifyCompanySet } from '@/api/system';
import { fstat } from 'fs';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'StockSetting',
  components: {
    DialogSetStaff
  }
})
export default class extends Vue {
  private activeName = 'first'
  private windowHg = window.innerHeight - 95;
  private insideTableData: any = []
  private outsideTableData: any = []
  private inStaffTableData: any = []
  private outStaffTableData: any = []
  private syncPartsFailTableData: any = []
  private autoChargeOffTableData: any = []
  private checkedActive = false
  private checkedActiveBtn = false
  private stockSettingChecked = false
  private stockAutoChargeOff = false
  private formWarning:any = {
    warning: '',
    number: ''
  }
  private selectUser=[]
  private InoutTypeData:any={};
  private PersonStock=false;

  created() {
    this.PersonStock = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.PersonStock);
    this.getStockInoutTypeList(1);
    this.getCompanySet();
    this.getSyncPartsFailList();
  }
  private tabsChange() {
    if (this.activeName === 'first') {
      this.getStockInoutTypeList(1);
    }
    if (this.activeName === 'second') {
      this.getStockInoutTypeList(2);
    }
    if (this.activeName === 'staffIn') {
      this.getStockInoutTypeList(3);
    }
    if (this.activeName === 'staffOut') {
      this.getStockInoutTypeList(4);
    }
    if (this.activeName === 'chargeOff') {
      this.getShellRecordList();
    }
    
  }
  private getStockInoutTypeList(type:number) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    switch (type) {
      case 1:
        pamars.type = 1;
        pamars.source_type = 1;
        break;
      case 2:
        pamars.type = 2;
        pamars.source_type = 1;
        break;
      case 3:
        pamars.type = 1;
        pamars.source_type = 5;
        break;
      case 4:
        pamars.type = 2;
        pamars.source_type = 5;
        break;
    }
    getStockInoutTypeList(pamars).then((res:any) => {
      if (type === 1) {
        this.insideTableData = res.data.list;
      }
      if (type === 2) {
        this.outsideTableData = res.data.list;
      }
      if (type === 3) {
        this.inStaffTableData = res.data.list;
      }
      if (type === 4) {
        this.outStaffTableData = res.data.list;
      }
    });
  }
  private getShellRecordList(){
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.type = 11;
    getShellRecordList(pamars).then((res:any) => {
        this.autoChargeOffTableData = res.data.list;
    });
  }
  private addTypeHanld(type:number) {
    this.InoutTypeData = {};
    this.addType(type, '');
  }
  private addType(type: number, value:string) {
    let _type = '';
    switch (type) {
      case 1:
        _type = '入库类型';
        break;
      case 2:
        _type = '出库类型';
        break;
      case 3:
        _type = '员工入库类型';
        break;
      case 4:
        _type = '员工出库类型';
        break;
      default:
        _type = '';
    }

    this.$prompt('名称', _type, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: '请输入' + _type,
      inputPattern: /^.{1,10}$/,
      inputErrorMessage: '请输入1-10位' + _type,
      inputValue: value
    }).then(({ value }: any) => {
      this.addStockInoutType(value, type);
    }).catch(() => {
    });
  }
  private addStockInoutType(name:string, type:number) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.name = name;
    switch (type) {
      case 1:
        pamars.type = 1;
        pamars.source_type = 1;
        break;
      case 2:
        pamars.type = 2;
        pamars.source_type = 1;
        break;
      case 3:
        pamars.type = 1;
        pamars.source_type = 5;
        break;
      case 4:
        pamars.type = 2;
        pamars.source_type = 5;
        break;
    }

    if (this.InoutTypeData && this.InoutTypeData.id) {
      pamars.id = this.InoutTypeData.id;
      editorStockInoutType(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.getStockInoutTypeList(type);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addStockInoutType(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.getStockInoutTypeList(type);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private editTypeHanld(row:any, type:number) {
    this.InoutTypeData = row;
    this.addType(type, this.InoutTypeData.name);
  }

  private deleteType(val:any, type:number) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let pamars:any = {};
        pamars.user_id = UserModule.getUserId;
        pamars.user_name = UserModule.getUserName;
        pamars.company_id = UserModule.getCompanyId;
        pamars.company_name = UserModule.getCompanyName;
        pamars.id = val.id;
        delStockInoutType(pamars).then((res:any) => {
          _this.showSuccessMsg(res.msg);
          _this.getStockInoutTypeList(type);
        }).catch(err => {
          _this.showErrorMsg(err.msg);
        });
      })
      .catch(() => {});
  }

  private getCompanySet() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanySet(params).then(res => {
      if (res.data && res.data.companySet) {
        this.checkedActive = parseInt(res.data.companySet.is_sync_spare_parts) === 1;
        this.checkedActiveBtn = parseInt(res.data.companySet.is_sync_spare_parts) === 1;
        this.stockSettingChecked = parseInt(res.data.companySet.is_stock_out_set) === 1;
        this.formWarning.warning = parseInt(res.data.companySet.is_stock_warning) === 1;
        this.formWarning.number = res.data.companySet.stock_warning_number;
        this.stockAutoChargeOff = parseInt(res.data.companySet.is_stock_auto_charge_off) === 1;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private getSyncPartsFailList() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    getSyncPartsFailList(params).then(res => {
      if (res.data && res.data.list) {
        this.syncPartsFailTableData = res.data.list;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private setStockWarningUser() {
    this.getStockWarningUserList();
  }
  // 预警人员接口
  private getStockWarningUserList() {
    let that = this;
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName
    };
    getStockWarningUserList(params)
      .then(res => {
        if (res.data) {
          this.selectUser = res.data.list;
        }
        this.dialogSetStaffVisible = true;
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  private selectUserConfirm(userList:any) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName
    };
    let userLists:any = [];
    userList.forEach((element:any) => {
      let user:any = {};
      user.user_id = element.user_id ? element.user_id : element.id;
      user.user_name = element.user_name ? element.user_name : element.name;
      userLists.push(user);
    });
    pamars.user_data = JSON.stringify(userLists);
    addStockWarningUser(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.dialogSetStaffVisible = false;
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private saveStockCompanySet(val:number) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    switch (val) {
      case 1:
        pamars.is_sync_spare_parts = this.checkedActive ? '1' : '0';
        break;
      case 2:
        pamars.is_stock_out_set = this.stockSettingChecked ? '1' : '0';
        break;
      case 3:
        pamars.is_stock_warning = this.formWarning.warning ? '1' : '0';
        pamars.stock_warning_number = this.formWarning.number;
        break;
      case 4:
        pamars.is_stock_auto_charge_off = this.stockAutoChargeOff ? '1' : '0';
        break;
    }
    this.saveCopanySet(pamars);
  }
  private saveCopanySet(params:any) {
    modifyCompanySet(params).then(res => {
      this.showSuccessMsg((res as any).msg);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private tabBefore(activeName: any) {
    if (activeName === 'empty-1' || activeName === 'empty-2') {
      return false;
    }
  }
  private dialogSetStaffVisible = false
  private closeStaff(val: any) {
    this.dialogSetStaffVisible = val;
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
